export const createOptanonWrapper = (resolve: (onetrust: OneTrust) => void) => {
  return () => resolve(window.OneTrust)
}
